<template>
    <tr>
        <td>
            {{ row.label }}&ndash;{{ parseInt(row.label, 10) + 5 }}
        </td>
        <td v-for="(rates, index) in chosenRates">
            {{ currencyFormat(row.data[index]) }}
        </td>
        <td>{{currencyFormat(difference)}}</td>
        <td>{{roundValue(percent)}}%</td>
    </tr>
</template>

<script>
    import {mapState} from 'vuex';
    import currencyFormat from 'mixins/currencyFormat';
    import roundValue from "mixins/roundValue";

    export default {
        name: 'age-group-row',
        mixins: [
            currencyFormat,
            roundValue
        ],
        props: {
            row: {
                type: Object,
                default: null,
            },
        },
        computed: {
            ...mapState('discountRateComparison', [
                'chosenRates',
            ]),
            difference() {
                return this.row.data[0] - this.row.data[1];
            },
            percent() {
                return (1 - (this.row.data[0] / this.row.data[1]))  * 100;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// AgeGroupRow.vue?47b91b68